export const deviceTypeConstants = {
    DEVICE_TYPE_LIST_REQUEST: "DEVICE_TYPE_LIST_REQUEST",
    DEVICE_TYPE_LIST_SUCCESS: "DEVICE_TYPE_LIST_SUCCESS",
    DEVICE_TYPE_LIST_FAILURE: "DEVICE_TYPE_LIST_FAILURE",
    DEVICE_TYPE_LIST_CLEAR: "DEVICE_TYPE_LIST_CLEAR",

    DEVICE_TYPE_DROPDOWN_REQUEST: "DEVICE_TYPE_DROPDOWN_REQUEST",
    DEVICE_TYPE_DROPDOWN_SUCCESS: "DEVICE_TYPE_DROPDOWN_SUCCESS",
    DEVICE_TYPE_DROPDOWN_FAILURE: "DEVICE_TYPE_DROPDOWN_FAILURE",
};
